// src/app/core/gsap/gsap.service.ts
import { Injectable } from '@angular/core';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

@Injectable({ providedIn: 'root' })
export class GsapService {
  private _ready = false;

  ready(): typeof gsap {
    if (!this._ready) {
      gsap.registerPlugin(ScrollTrigger);

      ScrollTrigger.config({
        ignoreMobileResize: true,
        autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load,resize'
      });

      this._ready = true;
    }
    return gsap;
  }

  killAll(): void {
    const g = this.ready();

    // Kill ScrollTriggers first
    try {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    } catch {
      /* noop */
    }

    // Then clear global timeline
    try {
      g.globalTimeline.clear();
    } catch {
      /* noop */
    }
  }
}
